import * as React from "react";

export interface IYearMonthProps {
  year: number;
  month: number;
}

export const YearMonth: React.FC<IYearMonthProps> = ({ year, month }) => {
  if (typeof year === "undefined" || typeof month === "undefined") {
    return <span />;
  }

  return (
    <span>
      1.{month}.{year}
    </span>
  );
};

export default YearMonth;
